export default {
  namespaced: true,
  state: {
    pending: false,
    facebook: null,
    instagram: null,
    youtube: null,
    facebookDef: "https://www.facebook.com/simya.restoraniv.classic.kovel/",
    instagramDef: "https://www.instagram.com/classic_kovel/",
    youtubeDef: "https://www.youtube.com/channel/UCK7efUZrNmekx4yVp-3DLog"
  },
  getters: {},
  mutations: {
    setProperty(store, [key, value]) {
      store[key] = value
    }
  },
  actions: {
    setDefault({state, commit}) {
      commit('setProperty', ['facebook', state.facebookDef]);
      commit('setProperty', ['instagram', state.instagramDef]);
      commit('setProperty', ['youtube', state.youtubeDef]);
    }
  }
}
